import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { object } from 'underscore';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  imagePath: any;
  imgURL: any;
  message: string;
  bearer;
  medias: any = [];
  allMedias: any = [];
  searchTerm: string = '';
  filterType: string = 'all';
  mediaForm: FormGroup;
  media;
  body = [];
  closeResult = '';
  status;
  errorMsg;
  onerror = [];
  copied = false;

  store_id;
  media_id;
  title;
  alt_text;
  caption;
  filesize;
  photo;
  uploadedImage;

  mediaData = [];
  expanded = [];
  page = 1;
  selectedPage = 25;
  start = 0;
  end = 0;
  loading = true;

  // Multi-select delete
  selectionMode = false;
  selectedIds = new Set<any>();
  deleting = false;

  buildForm() {
    this.mediaForm = this.formBuilder.group({
      store_id: [''],
      media_id: [''],
      title: [''],
      alt_text: [''],
      caption: [''],
      filesize: [''],
      photo: [''],
      url: ['']
    });

  }
  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private router: Router,
    private formBuilder: FormBuilder,
    public utils: UtilitiesService) { }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    console.log(this.bearer);
    this.store_id = localStorage.getItem('store_id');
    console.log(this.store_id);

    this.mediaForm = this.formBuilder.group({
      media_id: [this.media_id],
      title: [this.title],
      alt_text: [this.alt_text],
      caption: [this.caption],
      filesize: [this.filesize],
      photo: [this.photo],
      url: [this.photo]
    });

    this.getMedia();
  }

  getMedia() {
    this.svc.getMediaList(this.bearer).subscribe(res => {
      const medias = res['data'];

      this.allMedias = (typeof medias === 'object' ? medias : []).reverse();
      this.filterMedias();
      this.loading = false;
    })
  }

  filterMedias() {
    let filtered = [...this.allMedias];

    // Filter by search term
    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase().trim();
      filtered = filtered.filter(media => {
        const title = (media.title || '').toLowerCase();
        const mediaId = (media.media_id || '').toString().toLowerCase();
        return title.includes(term) || mediaId.includes(term);
      });
    }

    // Filter by type (image vs video)
    if (this.filterType === 'image') {
      filtered = filtered.filter(media => !this.isVideo(media.photo));
    } else if (this.filterType === 'video') {
      filtered = filtered.filter(media => this.isVideo(media.photo));
    }

    this.medias = filtered;
    this.page = 1;
    this.sliceCart();
  }

  setFilterType(type: string) {
    this.filterType = type;
    this.filterMedias();
  }

  clearSearch() {
    this.searchTerm = '';
    this.filterMedias();
  }

  getMediaList(store_id, media_id, title, alt_text, caption, filesize, photo) {

    // if (this.onerror[media_id]) {
    //   return;
    // }

    this.media_id = media_id;
    this.title = title;
    this.store_id = store_id;
    this.alt_text = alt_text;
    this.caption = caption;
    this.filesize = filesize;
    this.photo = photo;
    console.log('media_id', this.media_id);
    console.log('title', this.title);

    this.mediaForm = this.formBuilder.group({
      store_id: [this.store_id],
      media_id: [this.media_id],
      title: [this.title],
      alt_text: [this.alt_text],
      caption: [this.caption],
      filesize: [this.filesize],
      photo: [this.photo],
      url: [this.photo]
    });
  }

  updateMedia() {
    let title = this.mediaForm.get('title').value
    this.media_id = this.media_id;
    this.body = this.mediaForm.value['media_id'];
    console.log('this.uploadedImage', this.uploadedImage);
    console.log("this.imgURL", this.imgURL);
    if (this.photo == this.photo) {
      this.uploadedImage = this.photo;
    }
    this.svc.updateMedia(this.mediaForm.value['store_id'], this.media_id, this.mediaForm.value['title'], this.mediaForm.value['caption'], this.mediaForm.value['alt_text'], this.mediaForm.value['filesize'], this.photo, this.bearer).subscribe(
      data => {
        console.log('submit done');
        this.router.navigate(['/dashboard/gallery']);
        this.modalService.dismissAll();
        this.getMedia();
        this.utils.notify.showSuccess(this.utils.translate("Updated Successfully!"));
      },
      error => {
        this.errorMsg = error['error']['message'];
        console.log(this.errorMsg);
        this.utils.notify.showError(this.utils.translate("Update Failed!"));
      },
    );
  }

  openModal(content, media_id) {

    // if (this.onerror[media_id]) {
    //   return;
    // }

    this.modalService.open(
      content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'modal-customer',
      centered: true,
      backdrop: 'static'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openModalUploade(uploade) {
    this.modalService.open(
      uploade, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: 'modal-uploade',
      centered: true,
      backdrop: 'static'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  open() {
    const modalRef = this.modalService.open(UploadImageComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.id = 10;
    modalRef.result.then((result) => {
      console.log(result);
    }).catch((error) => {
      console.log(error);
    });
  }

  preview(files: any) {
    if (files.length === 0) {
      console.log(files.size, files.name, files.type);
      return;
    }

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      console.log(this.imgURL);

    }
  }

  removeMedia(media_id) {

    let body = {

      media_id: media_id
    }

    this.svc.removeMedia(this.store_id, this.media_id, this.bearer).subscribe(res => {
      console.log(res);
      this.getMedia();
      this.router.navigate(['/dashboard/gallery']);
      this.toast('Delete Successfully!', 3000);
    })
  }

  toast(msg: string, timeout: number) {
    if (msg == 'Update Failed!') {
      this.utils.notify.showError(msg);
    } else {
      this.utils.notify.showSuccess(msg);
    }
  }

  sliceCart() {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end = this.end > this.medias.length ? this.medias.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    this.mediaData = this.medias.slice(this.start, this.end);
    if (this.mediaData.length > 0) {
      this.mediaData.forEach((value, index) => {
        this.expanded[index] = false;
      });
    }
  }

  setErrorImg(e, media_id) {
    this.onerror[media_id] = true;
    e.target.src = 'https://cdn.estore5s.com/asset/images/estore_missing_product.png';
  }

  isVideo(url: string): boolean {
    if (!url) {
      return false;
    }
    if (url.startsWith('data:video/')) {
      return true;
    }
    try {
      const pathname = url.split('?')[0].split('#')[0];
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.3gp', '.avi', '.flv', '.mpeg', '.mkv'];
      const lowercasePath = pathname.toLowerCase();
      return videoExtensions.some(ext => lowercasePath.endsWith(ext));
    } catch (e) {
      return false;
    }
  }

  selectPage(page: any) {
    this.selectedPage = page;
    this.page = 1;
    this.sliceCart();
  }

  changePage(pageOfItems) {
    this.page = pageOfItems;
    this.sliceCart();
  }

  successModal(success) {
    this.modalService.open(
      success, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'sm',
      windowClass: 'modal-success',
      centered: true,
      backdrop: 'static'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      // location.reload();
      // window.location.reload();
      this.modalService.dismissAll();

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      //location.reload();
      this.modalService.dismissAll();
    });
    //location.reload();
  }

  imageSelect(photo) {

    this.photo = photo;
    console.log(this.photo);
  }

  files: File[] = [];
  data = [];

  onSelect(event) {

    this.files.push(...event.addedFiles);
    console.log('FILE IMAGE', this.files);

    var reader = new FileReader();
    this.imagePath = this.files;
    reader.readAsDataURL(this.files[0]);
    reader.onload = (_event) => {
      this.photo = reader.result;
      this.data.push(this.files[0].name.slice(0, -4))
      this.data.push(this.files[0].size)
      this.data.push(this.imgURL)
    }
    console.log('this.photo', this.photo);

    console.log("this.data", this.data['2']);
  }

  public copyUrl(url: any): void {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.copied = true;
    this.utils.notify.showSuccess(
      this.utils.translate('Link has been successfully copied !')
    );
    setTimeout(() => {
      if (this.copied) {
        this.copied = false;
      }
    }, 3000);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  // ---- Multi-select delete ----

  toggleSelectionMode() {
    this.selectionMode = !this.selectionMode;
    if (!this.selectionMode) {
      this.selectedIds.clear();
    }
  }

  cancelSelection() {
    this.selectionMode = false;
    this.selectedIds.clear();
  }

  // A card click either toggles its selection (in selection mode) or opens the details modal.
  onCardClick(content, media) {
    if (this.selectionMode) {
      this.toggleSelect(media);
      return;
    }
    this.openModal(content, media.media_id);
    this.getMediaList(media.store_id, media.media_id, media.title, media.alt_text, media.caption, media.filesize, media.photo);
  }

  toggleSelect(media) {
    if (this.selectedIds.has(media.media_id)) {
      this.selectedIds.delete(media.media_id);
    } else {
      this.selectedIds.add(media.media_id);
    }
  }

  isSelected(media): boolean {
    return this.selectedIds.has(media.media_id);
  }

  get allOnPageSelected(): boolean {
    return this.mediaData.length > 0 && this.mediaData.every(m => this.selectedIds.has(m.media_id));
  }

  toggleSelectAllPage() {
    if (this.allOnPageSelected) {
      this.mediaData.forEach(m => this.selectedIds.delete(m.media_id));
    } else {
      this.mediaData.forEach(m => this.selectedIds.add(m.media_id));
    }
  }

  confirmDeleteSelected() {
    const count = this.selectedIds.size;
    if (!count) {
      return;
    }
    this.utils.msgBox.open({
      title: this.utils.translate('Delete Media'),
      message: this.utils.translate('Delete {0} selected item(s)? This action cannot be undone.', [count]),
      icon: 'warning',
      buttonList: [
        { type: 'spacing' },
        { text: this.utils.translate('Cancel') },
        { text: this.utils.translate('Delete'), style: 'danger', onClick: () => this.deleteSelected() },
        { type: 'spacing' },
      ],
    });
  }

  deleteSelected() {
    const targets = (Array.isArray(this.allMedias) ? this.allMedias : [])
      .filter(m => this.selectedIds.has(m.media_id));
    if (!targets.length) {
      return;
    }

    this.deleting = true;
    const requests = targets.map(m =>
      this.svc.removeMedia(m.store_id || this.store_id, m.media_id, this.bearer)
        .pipe(catchError(() => of({ __error: true })))
    );

    forkJoin(requests).subscribe((results: any[]) => {
      this.deleting = false;
      const failed = results.filter(r => r && r.__error).length;

      this.selectionMode = false;
      this.selectedIds.clear();
      this.page = 1;
      this.getMedia();

      if (failed === 0) {
        this.utils.notify.showSuccess(this.utils.translate('{0} media deleted successfully!', [targets.length]));
      } else {
        this.utils.notify.showError(
          this.utils.translate('{0} of {1} deletions failed. Please try again.', [failed, targets.length]),
          this.utils.translate('Delete Failed!')
        );
      }
    });
  }

}
